var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initMarqueeBar = /* @__PURE__ */ __name(($el, duration) => {
  const handleMarqueeResize = /* @__PURE__ */ __name(() => {
    var _a;
    if ((_a = $el.children[0]) == null ? void 0 : _a.children.length) {
      const initialChildren = [...$el.children[0].children];
      const initialChildren2 = [...$el.children[1].children];
      while ($el.children[0].clientWidth < $el.clientWidth) {
        initialChildren.forEach((child) => {
          const newChild = child.cloneNode(true);
          newChild.setAttribute("aria-hidden", "true");
          newChild.removeAttribute("data-shopify-editor-block");
          newChild.querySelectorAll("[data-shopify-editor-block]").forEach((element) => {
            element.removeAttribute("data-shopify-editor-block");
          });
          $el.children[0].appendChild(newChild);
        });
        initialChildren2.forEach((child) => {
          const newChild = child.cloneNode(true);
          newChild.removeAttribute("data-shopify-editor-block");
          newChild.querySelectorAll("[data-shopify-editor-block]").forEach((element) => {
            element.removeAttribute("data-shopify-editor-block");
          });
          $el.children[1].appendChild(newChild);
        });
      }
      $el.style.setProperty("--animate-duration", `${duration}`);
    }
  }, "handleMarqueeResize");
  return {
    handleMarqueeResize
  };
}, "initMarqueeBar");
window._sections["initMarqueeBar"] = initMarqueeBar;
